import { reportsTransactionsDailyCountOps } from "../../api/operations";
import { entityFactory } from "../../hooks/useEntity";
import dayjs from "dayjs";
import { ROLE } from "../../Auth/useRole";
import { ContainerTransactionFilter } from "../../api/types";
import { formatToUtc } from "../../helpers/timeUtils";
import { defineEntity } from "../../api/entity";

export const conf = defineEntity({
  ...entityFactory("transaction-charts"),
  endpoint: "reports/transactions-daily-count",
  operations: reportsTransactionsDailyCountOps,
  roleView: [ROLE.TRANSACTION_VIEW],
  roleAdmin: [ROLE.TRANSACTION_VIEW],
  singularName: (t) => t("Transaction chart"),
  name: (t) => t("Transaction charts"),
  initialFilter: {
    from: dayjs().startOf("week").format(),
    to: dayjs().endOf("week").format(),
  },
  syncCustomerFilter: true,

  filterFormatter: (filter: ContainerTransactionFilter) => {
    return {
      ...filter,
      to: formatToUtc(filter?.to),
      from: formatToUtc(filter?.from),
    };
  },
});

export default conf;
